import React from 'react';
import { withStyles } from '@material-ui/core';
import { Route, Switch, Redirect } from "react-router-dom";
import Home from './Home/Home';
import Contacts from './Contacts/Contacts';
import { TransitionGroup, CSSTransition } from "react-transition-group";
import './transitions.css';

import styles from './MainContainer.css';
import Disclaimer from './Disclaimer/Disclaimer';
import Download from './Download/Download';
import Method from './Method/Method';
import Gallery from './Gallery/Gallery';
import Cookies from './Policies/Cookies';
import PrivacyPolicy from './Policies/PrivacyPolicy';

function MainContainer(props) {
    const {classes} = props;

    return (
        <main className={classes.mainContent}>

            {/* <div className={classes.toolbarSpacer} /> */}

            <TransitionGroup>
                <CSSTransition
                  key={props.location.key}
                  classNames="fade"
                  timeout={300}
                >
                    <Switch location={props.location}>
                        <Route exact path="/" component={Home} />
                        <Route exact path="/method" component={Method} />
                        <Route exact path="/gallery" component={Gallery} />
                        <Route exact path="/contact" component={Contacts} />
                        <Route exact path="/download" component={Download} />
                        <Route exact path="/disclaimer" component={Disclaimer} />
                        <Route exact path="/cookies" component={Cookies} />
                        <Route exact path="/privacy" component={PrivacyPolicy} />
                        <Route render={()=>(
                            <Redirect to="/"></Redirect>
                        )}/>
                    </Switch>
                </CSSTransition>
            </TransitionGroup>
        </main>
    );
}

export default withStyles(styles, {withTheme: true})(MainContainer);